<template>
    <div>
        <hr style="border: 1px solid">
        <h3 style="font-weight: bold">bezahlte Überstunden</h3>
        <table class="table">
            <tr>
                <td>Employee Name</td>
                <td>Date</td>
                <td>Comment</td>
                <td>Hours Paid</td>
                <td>Action</td>
            </tr>
          <tr v-bind:class="{ 'tr-red': !checked, 'tr-green': checked }">
              <td>
                <select
                  v-on:change="onChangePaidOvertime"
                  v-if="employeesLoaded"
                  v-model="entry.employeeId"
                  class="form-control">
                  <option
                    v-for="employee in employees"
                    v-bind:value="employee.id"
                    :key="employee.id">
                    {{ employee.name}}
                  </option>
                </select>
              </td>
              <td>
                <datepicker 
                  @input="onChangePaidOvertime"
                  :clear-button="true"
                  v-model="entry.markedOn"
                  :value="date"
                  class="text-box single-line" />
              </td>
              <td>
                <textarea
                  @input="onChangePaidOvertime"
                  v-model="entry.comment"
                  lazy
                  debounce="1000"
                  class="form-control">
                </textarea>
              </td>
              <td>
                <input
                  @input="onChangePaidOvertime"
                  v-model="entry.hoursPaid"
                  class="form-control text-box single-line"
                  type="number" />
              </td>
              <td>
                <div v-if="filled">
                  <button
                    v-on:click="submitPaidOvertime" 
                    type="button"
                    class="btn btn-success"
                    >Submit</button>
                </div>
                <div v-else>
                  <button
                    v-on:click="submitPaidOvertime"
                    type="button"
                    class="btn btn-secondary disabled"
                    >Submit</button>
                </div>
              </td>
            </tr> 
        </table>
    </div>
</template>

<script>
  import axios from "axios";
  import moment from 'moment';
  import datepicker from "vuejs-datepicker";

  export default {
    components: { datepicker },
    name: "paidovertime", // component name
    data() {
      var date = moment().startOf("month").format("yyyy-MM-DD");
      return {
        minimumLeaveDate: moment().subtract(30, 'd'),
        checked: false,
        filled: false,
        employees: [],
        date: date,
        employeesLoaded: false,
        entry: {
          UserId: 'sample', // to avoid validation error
        }
      };
    },
    methods: {
      submitPaidOvertime: function () {
        this.entry.markedOn = moment(this.entry.markedOn).format("yyyy-MM-DD")
        const { employeeId, markedOn, comment} = this.entry;
        if (employeeId && markedOn && comment) {
          axios({ 
            method: "POST",
            "url": process.env.VUE_APP_API_PATH + "paidovertime/",
            data: this.entry
            })
            .then(result => {
              //Changes have been saved
              console.log('Success');
              this.checked = true;
            }, error => {
              //Changes have not been saved
              //console.error(error);
              this.checked = false;
            });
        }
      },
      onChangePaidOvertime: function (event) {
        this.checked = false;
        const { employeeId, markedOn, comment, hoursPaid} = this.entry;
        if (employeeId && markedOn && comment && hoursPaid) {
          this.filled = true;
        }
      },
      loadComponentData: function () {
        // Load Employees
        axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "user/get" }).then(result => {
          this.employees = result.data.filter(d => (!d.leaveDate || d.leaveDate < this.minimumLeaveDate))
          this.employeesLoaded = true;
        }, error => {
          this.employeesLoaded = false;
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        });
      }
    },
    mounted() {
      this.loadComponentData();
    }
  };
</script>